import type { AppDataInterface } from '~/types/AppData/AppDataInterface';
import { createContextId } from '@builder.io/qwik';

export const AppDataContext = createContextId<AppDataInterface>('appData');
